import React from 'react';

const SplitArrowIcon = (props) => (
  <svg viewBox="0 0 18 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.151.037C4.054.12 1.994 1.864.9 2.794c1.094.93 3.154 2.669 3.251 2.75v-1.99h1.53A2.53 2.53 0 0 1 8.235 6.1c.003 2.13 0 3.912 0 5.862h1.53c-.005-1.954 0-4.036 0-5.862a2.53 2.53 0 0 1 2.554-2.548h1.53v1.991c.096-.081 2.157-1.82 3.25-2.75a2436.8 2436.8 0 0 0-3.25-2.757V2.03h-1.53a4.07 4.07 0 0 0-3.32 1.721A4.067 4.067 0 0 0 5.681 2.03h-1.53V.037Z" />
  </svg>
);

export default SplitArrowIcon;
